export default "__VITE_ASSET__DTph9r0b__"